<template>
  <div class="content">
    <div class="content-top">
      <div class="content-top-item">
        <div><img style="width: 74px;height: 53px;" src="../../../assets/image/foundation/total.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.gantryCount || 0}}</p>
          <p style="font-size: 18px;color: #999">设备总数</p>
        </div>
      </div>
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/on-line.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.onlineCount || 0}}</p>
          <p style="font-size: 18px;color: #999">在线设备</p>
        </div>
      </div>
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/off-line.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.offlineCount || 0}}</p>
          <p style="font-size: 18px;color: #999">离线设备</p>
        </div>
      </div>
      <div class="content-top-item" style="margin-right: 0;">
        <div><img src="../../../assets/image/foundation/alarm.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.alarmCount || 0}}</p>
          <p style="font-size: 18px;color: #999">报警设备</p>
        </div>
      </div>
    </div>
    <div class="equipment-list">
      <div class="top">
        <div class="top-left">
          <span style="color: #666;margin-right: 3vw;font-size: 16px">龙门吊设备列表</span>
          <span style="color: #666;font-size: 16px"><span class="circle" style="background: #10B33B"></span>在线</span>
          <span style="margin: 0 2vw;font-size: 16px"><span class="circle" style="background: #999999"></span>离线</span>
          <span style="font-size: 16px"><span class="circle" style="background: #D81E06"></span>报警</span>
        </div>
        <el-button size="small" @click="addEquipmentDialog = true" class="button-add">添加</el-button>
      </div>
      <div class="equipment-item">
        <div v-for="item in elevatorList" :key="item.id" :style="{ background: item.status == 0? '#D8D8D8' : (item.status == 1? '#DBE2EF' : item.status == 2? '#F7A69B' : '')}" style="height: 200px;padding: 18px 0;">
          <p style="font-size: 20px;">
            <span v-if="item.status == '0'" class="big-circle" style="background: #999999;"></span>
            <span v-else-if="item.status == 1" class="big-circle" style="background: #10B33B;"></span>
            <span v-else-if="item.status == 2" class="big-circle" style="background: #D81E06;"></span>
            {{item.name}}</p>
          <div style="width: 70%;margin: 2vh auto;display: flex;justify-content: space-between;">
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-between;height: 7vh;">
              <p style="font-size: 18px">累计工作时间</p>
              <p style="font-size: 18px">{{item.equipGantryRecord? item.equipGantryRecord.alltime : 0}}小时</p>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-between;height: 7vh;">
              <p style="font-size: 18px">运行状态</p>
              <p style="font-size: 18px; width: 4.5vw;">
                <span v-if="item.status == 0">{{item.isOnline}}</span>
                <span v-else-if="item.status == 1">{{item.isOnline}}</span>
                <span v-else-if="item.status == 2" style="color: #D81E06;">
                  <template v-if="item.equipGantryAlarmDetail.alarmName.length > 4">
                    <marquee style="position: relative;top: 5px;font-family: SourceHanSansCN-Medium;font-size: 18px;font-weight: 500;color: #D21B1B;" behavior="scroll" scrollamount="4" direction="left">
                      {{item.equipGantryAlarmDetail.alarmName}}
                    </marquee>
                  </template>
                  <template v-else>
                    {{item.equipGantryAlarmDetail.alarmName}}
                  </template>
                  </span>
              </p>
            </div>
          </div>
          <p>
            <span class="button" style="margin-right: 2vw" @click="openDetail(item.deviceId)">设备详情</span>
            <span class="button" @click="toRecord(item.id, item.name)">监测记录</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 添加设备弹出框 -->
    <el-dialog
      :visible.sync="addEquipmentDialog"
      center
      width="500px">
      <p slot="title" style="padding: 11px 24px;font-size: 16px;text-align: left;background:#ECF0F5;">设备添加</p>
      <el-form :model="addForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="设备名称：" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备编号：" prop="deviceId">
          <el-input v-model="addForm.deviceId" placeholder="请输入设备编号"></el-input>
        </el-form-item>
        <el-form-item label="型号规格：" prop="standards">
          <el-input v-model="addForm.standards" placeholder="请输入型号规格"></el-input>
        </el-form-item>
        <el-form-item label="设备厂家：" prop="machType">
          <el-select v-model="addForm.machType" placeholder="请选择设备厂家">
            <el-option v-for="item in types" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装单位：" prop="installUnit">
          <el-input v-model="addForm.installUnit" placeholder="请输入安装单位"></el-input>
        </el-form-item>
        <el-form-item label="班组：" prop="teamsId">
          <el-select v-model="addForm.teamsId" placeholder="请选择班组">
            <el-option  v-for="item in teams" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addEquipmentDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')" style="background: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设备详情弹出框 -->
    <el-dialog
      :visible.sync="equipmentDetailDialog"
      center
      width="500px">
      <p slot="title" style="padding: 11px 24px;font-size: 18px;text-align: left;background:#ECF0F5;">设备详情</p>
      <el-form label-width="160px">
        <el-form-item label="设备名称：">{{currentInfo.name}}</el-form-item>
        <el-form-item label="设备编号：">{{currentInfo.deviceId}}</el-form-item>
        <el-form-item label="型号规格：">{{currentInfo.standards}}</el-form-item>
        <el-form-item label="设备厂家：">{{getTypeName(currentInfo.machType)}}</el-form-item>
        <el-form-item label="安装单位：">{{currentInfo.installUnit}}</el-form-item>
        <el-form-item label="班组：">{{currentInfo.teamsName}}</el-form-item>
        <el-form-item label="安装时间：">{{currentInfo.createDate}}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="equipmentDetailDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        addEquipmentDialog: false,    // 添加设备弹出框
        equipmentDetailDialog: false,    // 设备详情弹出框
        projectId: util.session.get('groupId'),
        elevatorList: [],       //  升降机列表
        towerId: '',
        deviceId: '',
        addForm: {},  
        count: {},   // 升降机数量
        rules: {
          name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
          machType: [ { required: true, message: '请选择厂家名称', trigger: 'blur' }],
          deviceId: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
          // teamsId: [ { required: true, message: '请选择班组', trigger: 'blur' }],  
          installUnit: [ { required: true, message: '请输入安装单位', trigger: 'blur' }],   
          standards: [ { required: true, message: '请输入型号规格', trigger: 'blur' }],
        },
        types: [
            { name: '江智龙门吊', value: '5' },
        ],
        groups: [],
        teams: [],
        currentInfo: {},    // 点击查看设备详情
            
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
      this.getList()
      this.getNumber()
      this.getTeams()
      this.getNumber()
    },
    mounted() {
     
    },
    methods: {
      //获取龙门吊数量
      getNumber(){
        myHttp.gantryStatis({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            this.count = resp.data.data
          }
        })
      },

      //
      getTypeName(value) {
        for(let i =0;i<this.types.length;i++){
          if(this.types[i].value == value) {
            return this.types[i].name
          }
        }
      },

      //获取设备
      getList(){
        myHttp.selectEquipGantryPage({
            projectId:this.projectId,
            pageSize: 10000,
            pageNum: 1
        }).then(resp => {
          console.log(resp);
            if(resp.data.code=='200'){
              const list = resp.data.data.pageInfo.list || []
              // status  运行状态 0 离线 1 在线 2 报警
              list.forEach(item => {
                if(item.alarm == 1) {
                  item.status = 2
                }else{
                  if(item.isOnline == '在线') {
                    item.status = 1
                  }else if(item.isOnline == '离线') {
                    item.status = 0
                  }
                }
              })
              this.elevatorList = list
              if(list.length>0 && this.towerId==''){
                  this.towerId = list[0].id
                  this.deviceId = list[0].deviceId
              }
            }
        })
      },
    // 获取班组
    getTeams() {
      let that = this
      myHttp.getTeamsListtz({
        projectId: util.session.get('groupId')
      }).then(function(resp) {
          if (resp.data.code == '200') {
            that.teams = resp.data.data.teamsList || []
          } else {
            that.$message.error(resp.data.msg)
          }
        }
      )
    },

    // 增加
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.addForm.projectId = that.projectId
           myHttp.createEquipGantry(that.addForm).then( function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.addEquipmentDialog = false
                that.getList()
              } else {
                that.$message.error(resp.data.msg)
              }
            }
          )
        } else {
          return false;
        }
      });
    },


      //  打开设备详情
      openDetail(deviceId){
        for(let i =0; i<this.elevatorList.length; i++){
          if(deviceId == this.elevatorList[i].deviceId){
            this.currentInfo = this.elevatorList[i]
          }
        }
        this.equipmentDetailDialog = true
      },

      // 去监测记录
      toRecord(id, name){
        this.$router.push({
          path: '/gantryCraneRecord',
          query: {
            id,
            name
          }
        })
      }
    },
  }
</script>

<style scoped>
.content-top{
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.content-top-item{
  display: flex;
  width: calc((100% - 48px) / 4);
  height: 182px;
  align-items: center;
  justify-content: space-between;
  padding: 1.5vh 4vw;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 16px;
}
.equipment-list{
  height: calc(100% - 198px);
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.top{
  height: 56px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #E7E7E7;
}
.button-add:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.circle{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 20px;
  margin-right: 8px;
}
.big-circle{
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 20px;
  margin-right: 8px;
}
.equipment-item{
  height: calc(100% - 58px);
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 1vh 2vw;
  padding-right: 0;
  overflow: auto;
}
.equipment-item > div{
  width: 22%;
  height: 18vh;;
  padding: 1vh 0;
  margin-right: 2vw;
  margin-bottom: 1vw;
  border-radius: 6px;
  background: #DBE2EF;
  box-shadow: 4px 4px 12px 0px rgba(77, 110, 177, 0.3);
}
.el-pagination{
  border-radius:  0 0 6px 6px;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
.button{
  width: 80px;
  height: 34px;
  border-radius: 6px;
  padding: 4px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 16px;
  cursor: pointer;
}

.content >>> .el-icon-close:before{
  /* content: ''; */
  color: #9E9E9E;
  font-size: 18px;
  position: relative;
  top: -4px;
}
.content >>> .el-dialog__header{
  padding: 0;
}
.content >>> .el-dialog{
  border-radius: 6px;
}
.dialog-title{
  height: 48px;
  background: #ECF0F5;
  font-size: 16px;
  color: #666;
  border-radius: 6px 6px 0px 0px;
  line-height: 48px;
}
.el-input{
  width: 300px;
}
.el-select{
  width: 300px;
}
</style>